/**
 * Shared email helper functions for manufacturer contact requests
 * Used by BrandInnerData and ProjectCMFAlignment components
 */

const SUPPORT_EMAIL = 'support@transparencycatalog.com';
const HI_SUSTAINABLE_MINDS = 'Hi Sustainable Minds,\n\n';

export const getStringInURLEncoding = (str: string): string => {
    return str.replaceAll(' ', '%20').replaceAll('\n', '%0D%0A');
};

export const getOutsideTCEmailBody = (companyName: string): string => {
    let body = HI_SUSTAINABLE_MINDS;
    body += `Please contact ${companyName} on our behalf to request they create `;
    body += `transparency documentation so they can be added to the Transparency Catalog. `;
    body += `We have manually added them to our Project and/or Library for now.\n\n`;
    body += `Thank you,\n\n`;
    body += `[Your name, title]\n\n`;
    return body;
};

export const getProductOutsideTCEmailBody = (companyName: string, productNames: string[]): string => {
    let body = HI_SUSTAINABLE_MINDS;
    body += `Please contact ${companyName} on our behalf to request they add `;
    body += `the following product(s) and/or their EPDs and material disclosures to their listing:\n\n`;

    if (productNames && productNames.length > 0) {
        productNames.forEach((productName) => {
            body += `${productName}\n`;
        });
    }

    body += `\nIt is OK to use our company name in the request.\n\n`;
    body += `Thank you,\n\n`;
    body += `[Your name, title]\n\n`;
    return body;
};

export const getFreeListingEmailBody = (companyName: string): string => {
    let body = HI_SUSTAINABLE_MINDS;
    body += `Please contact ${companyName} on our behalf to request they activate `;
    body += 'their listing and add their products. It is OK to use our company name in the request.\n\n';
    body += 'Thank you,\n\n';
    body += `[Your name, title]\n\n`;
    return body;
};

export const getMFROutsideTCEmailHref = (companyName: string): string => {
    const subject = getStringInURLEncoding(
        `Contact ${companyName} to create EPDs / material disclosures`,
    );
    const body = getStringInURLEncoding(getOutsideTCEmailBody(companyName));
    return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};

export const getProductOutsideTCEmailHref = (
    companyName: string,
    productNames: string[],
): string => {
    const subject = getStringInURLEncoding(`Contact ${companyName} to add products to their listing`);
    const body = getStringInURLEncoding(getProductOutsideTCEmailBody(companyName, productNames));
    return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};

export const getFreeListingEmailHref = (companyName: string): string => {
    const subject = getStringInURLEncoding(`Contact ${companyName} to add their products`);
    const body = getStringInURLEncoding(getFreeListingEmailBody(companyName));
    return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};
